import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"value":_vm.tooltip,"top":"","open-on-hover":false,"open-on-focus":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VIcon,{attrs:{"small":"","color":_vm.color},on:{"click":_vm.click}},[_vm._v("\n      "+_vm._s(_vm.custom_icon)+"\n    ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip_text))])])}
var staticRenderFns = []

export { render, staticRenderFns }